import React from 'react';
import { referrerInstance, FeaturedArtistsPage, FromShortLink, EBrand } from '@elc/common';
import { Route, Routes as Switch } from 'react-router-dom';
import About from '../screens/About';
import ArtistScreen from '../screens/Artist/Artist';
import Layout from '../components/layout/Layout';
import LearningCenter from '../screens/LearningCenter';
import LearningCenterPost from '../screens/LearningCenterPost';
import LookScreen from '../screens/Look/Look';
import Page404 from '../screens/Page404';
import StoreLayout from '../components/layout/storeLayout';
import Terms from '../screens/Terms';

import { pages } from './config';
import Faq from '../screens/Faq';
import { ProductScreen } from '../screens/Product';

const Routes = (): JSX.Element => {
  referrerInstance.setReferrer();
  return (
    <Switch>
      <Route element={<StoreLayout />}>
        <Route path={pages.BUNDLE} element={<LookScreen />} />
        <Route path={pages.LOOK_NEW} element={<LookScreen />} />
        <Route key="artist" path={pages.ARTIST} element={<ArtistScreen />} />
        <Route path={pages.PRODUCT} element={<ProductScreen />} />
        <Route path={pages.ROOT} element={<FeaturedArtistsPage brand={EBrand.Mac} />} />
      </Route>

      <Route element={<Layout />}>
        <Route path={pages.FROM_LINK} element={<FromShortLink />} />
        <Route path={pages.FAQ} element={<Faq type="customers" />} />
        <Route path={pages.FAQ_CONTENT_CREATORS} element={<Faq type="contentCreators" />} />
        <Route path={pages.ABOUT} element={<About />} />
        <Route path={pages.TERMS_OF_SERVICE} element={<Terms />} />
        <Route path={pages.LEARNING_CENTER_POST} element={<LearningCenterPost />} />
        <Route path={pages.LEARNING_CENTER} element={<LearningCenter />} />

        <Route path="*" element={<Page404 />} />
      </Route>
    </Switch>
  );
};

export default Routes;
